export const campaignsSearchRetailersByIdSelector = (state) =>
  (state.retailersCampaignsSearch &&
    state.retailersCampaignsSearch.byRetailerId) ||
  {}
